import LogoutModal from './LogoutModal';
export default LogoutModal;